import { apiProxyRequest } from "Api/apiProxyRequest";
import { encodeParameters } from "Api/utils";

import type { DeploymentImagesRequestProps, DeploymentImages } from "./types";

export const loadDeploymentCurrentImagesRequest = ({
  projectId,
  environmentId
}: DeploymentImagesRequestProps) => {
  const { projectId: encodedProjectId, environmentId: encodedEnvironmentId } =
    encodeParameters({ projectId, environmentId });

  return apiProxyRequest<DeploymentImages>(
    `/projects/${encodedProjectId}/environments/${encodedEnvironmentId}/deployments/current/images`
  );
};
